import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import {
  BackgroundModule,
  HeaderModule,
  LayoutModule,
  LogoModule
} from '../components';
import { LoginComponent } from './containers';
import { LoginResolver } from './resolvers';

const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
    resolve: { failed: LoginResolver }
  },
  {
    path: ':token',
    component: LoginComponent,
    resolve: { token: LoginResolver }
  }
];

@NgModule({
  imports: [
    CommonModule,
    TranslocoModule,
    RouterModule.forChild(routes),

    BackgroundModule,
    HeaderModule,
    LayoutModule,
    LogoModule
  ],
  declarations: [LoginComponent],
  providers: [LoginResolver]
})
export class LoginModule {}
